import Api from './api';

// ========== Products (Applications) ==========
export const getProducts = (productsOnly = false) => {
    let url = '/admin/products';
    if (productsOnly) url += '?productsOnly=true';
    return Api.get(url);
};

export const getProductGateways = (applicationId) => {
    return Api.get(`/admin/products/${applicationId}/gateways`);
};

export const ensureGatewayProduct = (applicationId, gatewayId) => {
    return Api.post('/admin/products/ensure-gateway-product', { applicationId, gatewayId });
};

export const toggleApplicationGateway = (applicationId, gatewayId, active) => {
    return Api.post('/admin/products/toggle-gateway', { applicationId, gatewayId, active });
};

// Lista planos disponíveis pra um produto (só os que têm tb_plan_periodicity cadastrado).
// Usado na criação de assinatura — plano-por-produto.
export const getPlansByApplication = (applicationId, excludeTrial = true) => {
    return Api.get(`/admin/products/${applicationId}/plans?excludeTrial=${excludeTrial ? 'true' : 'false'}`);
};

// ========== Plan Periodicities ==========
export const getPlanPeriodicities = (planId = null, applicationId = null, excludeTrial = false) => {
    let url = '/admin/products/plan-periodicities';
    const params = [];
    if (planId) params.push(`planId=${planId}`);
    if (applicationId) params.push(`applicationId=${applicationId}`);
    if (excludeTrial) params.push('excludeTrial=true');
    if (params.length > 0) url += '?' + params.join('&');
    return Api.get(url);
};

export const getPlanPeriodicityDetail = (planPeriodicityId) => {
    return Api.get(`/admin/products/plan-periodicities/${planPeriodicityId}`);
};

export const getNextPlanPeriodicityId = () => {
    return Api.get('/admin/products/plan-periodicities/next-id');
};

export const createPlanPeriodicity = (data) => {
    return Api.post('/admin/products/plan-periodicities', data);
};

export const updatePlanPeriodicity = (id, data) => {
    return Api.put(`/admin/products/plan-periodicities/${id}`, data);
};

export const getBillingModes = () => {
    return Api.get('/admin/products/billing-modes');
};

export const getAllowedBillingModes = (applicationId) => {
    return Api.get(`/admin/products/${applicationId}/allowed-billing-modes`);
};

export const getNextApplicationId = () => {
    return Api.get('/admin/products/next-id');
};

export const createProduct = (data) => {
    return Api.post('/admin/products/create', data);
};

export const updateProduct = (data) => {
    return Api.put('/admin/products/update', data);
};

export const deletePlanPeriodicity = (id) => {
    return Api.delete(`/admin/products/plan-periodicities/${id}`);
};

export const getNextFeatureId = () => {
    return Api.get('/admin/products/features/next-id');
};

export const createFeatureDapper = (data) => {
    return Api.post('/admin/products/features/create', data);
};

export const updateFeatureDapper = (data) => {
    return Api.put('/admin/products/features/update', data);
};

export const ensureGatewayPrice = (planPeriodicityId, gatewayId, price) => {
    return Api.post('/admin/products/ensure-gateway-price', { planPeriodicityId, gatewayId, price });
};
